import React from 'react';
import PropTypes from 'prop-types';

import './MiniCommentIcon.scss';
import { constructCn } from '../../../utilities/helperFunctions';

const MiniCommentIcon = ({ className, isActive }) => {
    const cn = constructCn(
        'component-Icons-MiniCommentIcon',
        className,
        isActive && 'active',
        !isActive && 'inactive'
    );
    return (
        <svg
            className={cn}
            width="30px"
            height="30px"
            viewBox="0 0 30 30"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g
                id="React/mini-comment-a"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
            >
                <rect id="Rectangle" x="0" y="0" width="30" height="30" />
                <g
                    id="mini-comment-fill"
                    transform="translate(6.000000, 7.000000)"
                >
                    <path d="M14.9072252,0 L2.09277482,0 C0.936952515,0 0,1.03959168 0,2.32202941 L0,10.3089388 C0,11.5913766 0.936952515,12.6309682 2.09277482,12.6309682 L3.6010034,12.6309682 L3.63365152,16 L6.84779895,12.6309682 L14.9072252,12.6309682 C16.0630475,12.6309682 17,11.5913766 17,10.3089388 L17,2.32202941 C17,1.03959168 16.0630475,0 14.9072252,0" />
                </g>
            </g>
        </svg>
    );
};

MiniCommentIcon.propTypes = {
    className: PropTypes.string,
    isActive: PropTypes.bool,
};

MiniCommentIcon.defaultProps = {
    className: '',
    isActive: false,
};

MiniCommentIcon.displayName = 'MiniCommentIcon';

export default React.memo(MiniCommentIcon);
